import { render, staticRenderFns } from "./style_configurator.vue?vue&type=template&id=5c3ca3a4&"
import script from "./style_configurator.vue?vue&type=script&lang=js&"
export * from "./style_configurator.vue?vue&type=script&lang=js&"
import style0 from "./style_configurator.vue?vue&type=style&index=0&id=5c3ca3a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports